/* eslint-disable */
<template>
  <div>
    <NavigationSubNav main-route="data" :title="actionName" />
    <div class="container-fluid pb-1">
      <Loader v-if="showLoader" :progress="progress" />

      <div v-else class="mb-sm-4 mx-3 my-4 row" style="top: 75px">
        <div class="col-lg-12">
          <div class="border">
            <div class="row p-4">
              <div class="col">
                <h5 class="h5 text-muted font-weight-bold">{{ title }}</h5>
                <p>{{ message }}</p>
              </div>
              <h4 class="text-danger">{{ preview.length }} duplicates found</h4>
            </div>

            <div v-if="preview.length" class="">
              <TableComponent
                :fields="fields"
                bordered
                :enable-select="false"
                :data="preview"
                :loading="tableLoading"
                :empty-text="emptyText"
                @sizeChange="handlePageSizeChange"
                @selected="handleSelection"
              >
              </TableComponent>
            </div>

            <div class="row mb-3 p-4 pt-3 px-3 py-3">
              <div class="col-lg-12">
                <div class="d-flex align-items-center">
                  <button
                    :disabled="duplicates.length !== 0 || isProcessing"
                    style="width: fit-content; padding-inline: 50px"
                    class="btn mr-2 action-btn btn-primary shadow float-left"
                    @click="beforeProceed"
                  >
                    <i v-if="isProcessing" class="el-icon-loading mr-2"></i>
                    Push
                  </button>
                  <a class="text-danger ml-4" @click="reset">Cancel</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- shows a prompt , properties are defined in Mixin Object -->
    <ProgressPrompt
      :width="promptWidth"
      :visible="isProgresPromptVisible"
      :cancel="promptCancel"
      :confirm="promptConfirm"
      :message="promptMessage"
      :title="promptTitle"
      :cancel-text="promptCancelText"
      :cancel-type="promptCancelClass"
      :confirm-text="promptConfirmText"
      :confirm-type="promptConfirmClass"
      @close="onPromptClose"
    />
  </div>
</template>

<script>
/**
 * @typedef {import("../../store/modules/data.old").Cell} Cell
 */

import NavigationSubNav from "../../components/NavigationSubNav.vue";
import Loader from "../../components/Loader.vue";
import TableComponent from "../../components/Table.vue";
import DataMixin from "./mixin";
import UploadResource from "../../api/fileResource";
import { META_DATA_CHECK_STAGE } from "../../store/stages";
import XLSX from "xlsx";
import { mapGetters } from "vuex";
import { random } from "../../utils";

const uploadResource = new UploadResource();

export default {
  name: "CheckFileDuplicates",
  components: {
    NavigationSubNav,
    Loader,
    TableComponent,
  },
  mixins: [DataMixin],
  data() {
    return {
      hasChanges: false,
      promptWidth: "39%",
      duplicates: [],
    };
  },
  computed: {
    /**
     * Get data state from store
     */
    ...mapGetters({
      originalFile: "data/file",
    }),

    title() {
      return "Check File Duplicates";
    },
    message() {
      if (!this.duplicates.length)
        return "Your data has been checked for duplicates and no duplicates were found.";
      return "Your data has been checked for duplicates and some duplicates were found.";
    },
    /**
     *
     * @see DataMixin.computed
     * @see Cell
     * @returns {Array<Cell>}
     */
    preview() {
      return this.duplicates.map((x) => x);
    },
    headers() {
      if (!this.preview.length) return [];
      // return Object.keys(this.preview[0]).filter((x) => !["$id", "__EMPTY"].includes(x));
      return Object.keys(this.preview[0]).filter((x) => !["$id", "__EMPTY"].includes(x));
    },
    cardHeaders() {
      var getCurrentFileData = JSON.parse(localStorage.getItem("getCurrentFileData"));
      console.log(getCurrentFileData);
      var getCurrentFileKeys = Object.keys(getCurrentFileData);
      return getCurrentFileKeys.map((x) => x);
    },
    cardBody() {
      var getCurrentFileData = JSON.parse(localStorage.getItem("getCurrentFileData"));
      console.log(getCurrentFileData);
      var getCurrentFileValues = Object.values(getCurrentFileData);
      return getCurrentFileValues.map((x) => x);
    },
  },
  mounted() {
    const temp = this.editting.map((x) => x);
    this.duplicates = this.findDuplicates(temp);
  },
  methods: {
    reset() {
      // this.reset_state();
      this.$router
        .push("/data/upload")
        .then(() => {})
        .catch((e) => console.log(e));
    },
    async proceedToCheckDB() {
      this.$progress.start();
      this.$router.push("/data/check-db-duplicates");
    },

    findDuplicates(data) {
      const dataType = this.$store.getters["data/getDataType"];

      const fieldMap = {
        Data: ["indicator", "period", "location", "datasource", "value_type"],
        indicator: ["full_name", "short_name"],
      };

      const fields = fieldMap[dataType] || [];

      if (!fields.length) return [];

      const seen = new Map();
      const duplicates = [];

      data.forEach((item) => {
        // Only consider specific fields, ignoring $id and value
        // const key = `${item.indicator}|${item.period}|${item.location}|${item.datasource}|${item.value_type}`;

        const key = fields.map((field) => (item && item[field] ? item[field] : "")).join("|");

        if (seen.has(key)) {
          if (seen.get(key) !== "added") {
            duplicates.push(seen.get(key));
            seen.set(key, "added");
          }
          duplicates.push(item);
        } else {
          seen.set(key, item);
        }
      });

      return duplicates;
    },

    /**
     * confirm proceed
     */
    beforeProceed() {
      // if (!this.hasChanges) return this.proceed();
      this.proceed();
    },
    /**
     *Navigates to  next index on the  Next index Navigation Bar
     @see {NavigationSubNav}
     */
    async proceedNormalization() {
      this.$progress.start();
      this.$router.push("/data/check-meta-data");
    },
    /**
     *Navigates to  next index on the  Next index Navigation Bar
     @see {NavigationSubNav}
     */
    async proceed() {
      try {
        const file = this.createExcelFile();
        if (!file) {
          this.$notify({
            title: "Error",
            message: "Could not create file from data. Please try uploading again.",
            type: "error",
          });
          return;
        }

        const formData = new FormData();
        formData.append("name", localStorage.getItem("name"));
        formData.append("file_type", localStorage.getItem("file_type"));
        formData.append("ordinary_data", file);
        formData.append("application", "DMI");
        formData.append("type", "unnormalized");
        formData.append("approved", false);
        formData.append("frequency", localStorage.getItem("frequency") || "annual");

        await this.setRequestProgress(random(35, 55));
        this.$progress.start();
        this.isProcessing = true;

        uploadResource
          .create(formData)
          .then(async (response) => {
            console.log("Upload response:", response);
            const id = response.id || (response.data && response.data.id);
            if (!id) {
              console.error("ID not found in response", response);
              this.$notify({
                title: "Error",
                message: "Server returned an invalid response (missing ID).",
                type: "error",
              });
              return;
            }
            localStorage.setItem("currentRecordId", id);
            localStorage.setItem("getCurrentFileData", JSON.stringify(response));

            let responseData = [],
              responseDataObj = {};
            responseData.push(response);
            responseDataObj = {
              data: responseData,
            };
            await this.$store.dispatch("data/setData", responseDataObj.data);
            this.$store.commit("data/SET_STAGE", META_DATA_CHECK_STAGE);
            await this.setRequestProgress(100);

            this.$router
              .push("/data/check-meta-data")
              .then(() => {})
              .catch((e) => console.error(e));
          })
          .catch(async (error) => {
            console.error(error);
            this.$notify({
              title: "Error",
              message: "Failed to upload data.",
              type: "error",
            });
            await this.setRequestProgress(random(70, 90));
          })
          .finally(() => {
            this.$progress.done();
            this.isProcessing = false;
          });
      } catch (e) {
        console.error(e);
        this.isProcessing = false;
      }
    },
    /**
     *@see {DataMixin.methods}
     */
    save() {
      /**
       * @see DataMixin.methods.showProgressPrompt
       */
      this.showProgressPrompt(
        "Save progress",
        "Are you sure you want to save and continue later?",
        {
          cancel: "Continue",
          confirm: "Save and continue later",
          confirmClass: "primary",
          async confirmCallback() {
            this.$store.dispatch("data/storeData");
          },
        }
      );
    },

    /**
     * @param {Event} event
     * @param {Object} row
     */
    handleChange(value, row) {
      let cell = {};
      let _value = parseFloat(value, 10);
      if (!isNaN(_value)) cell[row.field.key] = _value;
      else cell[row.field.key] = value;

      cell.$id = row.item.$id;
      this.$store.dispatch("data/updateEditingCell", cell);
      this.hasChanges = true;
    },

    /**
     * @returns {(File|null)} file
     */
    createExcelFile() {
      /**
       * @type {Array<Cell>}
       */
      let data = JSON.parse(JSON.stringify(this.editting));
      if (!data.length) return null;

      data = data.map((cell) => {
        delete cell.$id;
        // eslint-disable-next-line prettier/prettier
        delete cell["__EMPTY"];
        if (cell.period) {
          cell.period = String(cell.period);
        }
        return cell;
      });

      const headers = Object.keys(data[0]);
      const entries = data.map((cell) => Object.values(cell));

      entries.unshift(headers);
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(entries);

      XLSX.utils.book_append_sheet(wb, ws, "sheet 1");

      const type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;";
      const blob = new Blob([XLSX.write(wb, { type: "array", bookType: "xlsx" })], {
        type,
      });
      const fileName = this.originalFile
        ? this.originalFile.name
        : localStorage.getItem("name") || "upload.xlsx";
      const file = new File([blob], fileName, {
        type,
        lastModified: new Date().getTime(),
      });

      return file;
    },
  },
};
</script>

<style lang="scss" scoped></style>
